export default "__VITE_PUBLIC_ASSET__19b36f6b__"